export default {"src":"/_next/static/media/no.cb4950a1.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};